/**
 * Recently-viewed products tracker (localStorage, client-side only).
 * Stores a compact snapshot (id, name translations, slug, price, image, unit)
 * so the UI can render the strip without a network roundtrip even after the
 * source products mutate or go offline.
 */

const STORAGE_KEY = 'sunify_recently_viewed_v1';
const MAX_ITEMS = 10;

const safeParse = (raw) => {
  try { return JSON.parse(raw) || []; } catch { return []; }
};

export const getRecentlyViewed = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const list = safeParse(raw);
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

/**
 * Push a product snapshot to the top of the list.
 * Idempotent: existing entries are de-duplicated by id and re-promoted.
 */
export const pushRecentlyViewed = (product) => {
  if (!product || !product.id) return;
  const snapshot = {
    id: product.id,
    translations: product.translations || {},
    price_eur: Number(product.price_eur) || 0,
    price_usd: Number(product.price_usd) || 0,
    image: (product.images && product.images[0]) || '',
    unit: product.unit || 'mb',
    discount: Number(product.discount) || 0,
    viewed_at: Date.now(),
  };
  try {
    const list = getRecentlyViewed().filter((p) => p.id !== product.id);
    list.unshift(snapshot);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
  } catch {
    // localStorage quota / disabled — silently ignore
  }
};

export const clearRecentlyViewed = () => {
  try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
};
